const SOFA_CONFIGURATOR_DIRECT_SOURCE_DIRECTION_HANDLES = new Set([
  'ecksofa-asti-leder-fur-hochsten-komfort',
  'stoff-sofa-asti-l-form',
  'ecksofa-asti-l-form-stoffsofa',
  'ecksofa-asti-l-mini-kompakt',
  'mini-ecksofa-asti-l-form-stoffsofa',
  'stoff-sofa-asti-l-form-mini',
  'leder-wohnlandschaft-catania-modern-bequem',
  'mini-leder-wohnlandschaft-catania-komfort-eleganz',
  'mini-xxl-leder-wohnlandschaft-catania-komfort-stil',
  'stoff-sofa-catania-u-form',
  'wohnlandschaft-catania-u-form-stoffsofa',
  'stoff-sofa-catania-xxl',
  'xxl-wohnlandschaft-catania-stoffsofa',
  'xxl-wohnlandschaft-catania-leder-komfort'
]);

const SOFA_CONFIGURATOR_PRODUCT_DIRECTION_SOURCE_FAMILIES = ['catania', 'wave'];
const SOFA_CONFIGURATOR_IMAGE_PREVIEW_ENABLED = false;
const SOFA_CONFIGURATOR_NO_PREVIEW_MESSAGE = 'Für diese individuelle Konfiguration steht aktuell kein Vorschaubild zur Verfügung.';

if (!customElements.get('sofa-configurator')) {
  customElements.define('sofa-configurator', class SofaConfigurator extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.overlay = this.querySelector('.sofa-configurator__overlay');
      this.dialog = this.querySelector('.sofa-configurator__dialog');
      this.form = document.getElementById(this.dataset.productFormId);
      this.error = this.querySelector('.sofa-configurator__error');
      this.materialGrid = this.querySelector('.sofa-configurator__material-grid');
      this.mainGrid = this.querySelector('[data-colors="main"]');
      this.accentGrid = this.querySelector('[data-colors="accent"]');
      this.accentStep = this.querySelector('[data-step="accent-color"]');
      this.directionStep = this.querySelector('[data-step="direction"]');
      this.directionGrid = this.querySelector('[data-directions]');
      this.extrasStep = this.querySelector('[data-step="extras"]');
      this.extrasGrid = this.querySelector('[data-extras]');
      this.singleColorButton = this.querySelector('.sofa-configurator__single-color');
      this.accentMaterialNote = this.querySelector('.sofa-configurator__accent-material-note');
      this.accentMaterialOptions = this.querySelector('.sofa-configurator__accent-material-options');
      this.liveSummary = this.querySelector('.sofa-configurator__live-summary');
      this.saved = this.querySelector('.sofa-configurator__saved');
      this.savedText = this.querySelector('.sofa-configurator__saved-text');
      this.placeSavedSummary();
      this.legalCheckbox = this.querySelector('.sofa-configurator__legal-checkbox');
      this.basePriceOutput = this.querySelector('[data-summary-base-price]');
      this.extrasPriceOutput = this.querySelector('[data-summary-extras-price]');
      this.totalPriceOutput = this.querySelector('[data-summary-total-price]');
      this.previewButton = this.querySelector('.sofa-configurator__generate-preview');
      this.pdfButton = this.querySelector('.sofa-configurator__download-pdf');
      this.mobilePreviewButton = this.querySelector('.sofa-configurator__mobile-preview');
      this.previewCacheToggle = this.querySelector('.sofa-configurator__cache-toggle-input');
      this.restorePreviewButton = this.querySelector('.sofa-configurator__restore-preview');
      this.previewStatus = this.querySelector('.sofa-configurator__preview-status');
      this.previewDisclaimer = this.querySelector('.sofa-configurator__preview-disclaimer');
      this.imageNote = this.querySelector('.sofa-configurator__image-note');
      this.productData = this.readProductData();
      // Ohne Bildgenerierung muss das Vorschaubild exakt der aktuell auf der
      // Produktseite gewaehlten Shopify-Variante entsprechen. Die fruehere
      // Referenzbild-Logik bevorzugte absichtlich Schwarz/Weiss und ist nur
      // fuer die KI-Bildgenerierung sinnvoll.
      this.originalSourceVariant = SOFA_CONFIGURATOR_IMAGE_PREVIEW_ENABLED
        ? this.findPreferredOriginalVariant()
        : (this.getCurrentVariant() || this.findPreferredOriginalVariant());
      this.applyOriginalSourceImage();
      this.fabricAccentSources = this.querySelector('.sofa-configurator__fabric-accent-sources');
      this.surchargeSources = this.querySelector('.sofa-configurator__surcharge-sources');
      this.state = { material: null, main: null, accent: null, accentMaterialKey: null, singleColor: false, direction: null, extras: new Set() };
      this.previewCache = new Map();
      this.currentPreview = null;
      this.lastFocused = null;
      this.captureOriginalImage(true);

      this.querySelector('.sofa-configurator__open')?.addEventListener('click', () => this.open());
      this.bindMoreColorsLink();
      this.querySelector('.sofa-configurator__edit')?.addEventListener('click', () => this.open());
      this.querySelector('.sofa-configurator__close')?.addEventListener('click', () => this.close());
      this.querySelector('.sofa-configurator__cancel')?.addEventListener('click', () => this.close());
      this.querySelector('.sofa-configurator__apply-cart')?.addEventListener('click', () => this.apply(true));
      this.pdfButton?.addEventListener('click', () => this.downloadConfigurationPdf());
      this.previewButton?.addEventListener('click', () => this.generatePreview());
      this.mobilePreviewButton?.addEventListener('click', () => {
        this.scrollToPreview();
        this.generatePreview();
      });
      this.restorePreviewButton?.addEventListener('click', () => this.restoreOriginalPreview());
      this.singleColorButton?.addEventListener('click', () => this.selectSingleColor());
      this.overlay?.addEventListener('click', (event) => { if (event.target === this.overlay) this.close(); });
      this.addEventListener('keydown', (event) => this.onKeydown(event));
      if (SOFA_CONFIGURATOR_IMAGE_PREVIEW_ENABLED) this.setupMobilePreviewObserver();
      this.querySelectorAll('.sofa-configurator__search').forEach((input) => {
        input.addEventListener('input', () => this.filterColors(input.dataset.search, input.value));
      });
    }

    placeSavedSummary() {
      if (!this.saved || !this.form) return;
      const productFormButtons = this.form.querySelector('.product-form__buttons');
      if (!productFormButtons) return;
      productFormButtons.insertBefore(this.saved, productFormButtons.firstChild);
    }

    bindMoreColorsLink() {
      const bind = () => {
        document.querySelectorAll('a[href$="#more-colors"]').forEach((link) => {
          if (link.closest('.product__link')) return;
          if (link.dataset.sofaConfiguratorBound === 'true') return;
          link.dataset.sofaConfiguratorBound = 'true';
          link.dataset.sofaConfiguratorLink = 'true';
          link.textContent = 'Andere Farben wählen →';
        });
      };
      bind();
      this.moreColorsObserver = new MutationObserver(bind);
      this.moreColorsObserver.observe(document.body, { childList: true, subtree: true });
    }

    readProductData() {
      try {
        return JSON.parse(this.querySelector('.sofa-configurator__product-data')?.textContent || '{}');
      } catch (error) {
        return { options: [], variants: [] };
      }
    }

    open() {
      this.lastFocused = document.activeElement;
      this.syncOriginalSourceWithProductPage();
      this.restoreOriginalPreview();
      this.captureOriginalImage();
      this.build();
      this.refreshConfiguredPreview({ quiet: true });
      this.clearError();
      this.overlay.hidden = false;
      this.lockPageScroll();
      const body = this.querySelector('.sofa-configurator__body');
      if (body) body.scrollTop = 0;
      window.setTimeout(() => this.querySelector('.sofa-configurator__close')?.focus(), 0);
    }

    syncOriginalSourceWithProductPage() {
      if (SOFA_CONFIGURATOR_IMAGE_PREVIEW_ENABLED) return;
      const variant = this.getCurrentVariant();
      if (!variant) return;

      this.originalSourceVariant = variant;
      const directionIndex = this.optionIndex(/^(ausrichtung|ottomane|ecke|kurze seite|lange seite)$/);
      const direction = directionIndex >= 0 ? variant.options?.[directionIndex] : '';
      if (direction) this.sourceDirection = direction;

      this.applyOriginalSourceImage();
      this.originalImage = null;
      this.captureOriginalImage(true);

      // Wurde der Konfigurator bereits einmal geoeffnet, kann die Variante auf
      // der Produktseite inzwischen gewechselt worden sein. Dann auch die
      // sichtbare Ausrichtungswahl wieder mit der Produktseite synchronisieren.
      if (this.dataset.built === 'true' && direction && this.directionIndex >= 0) {
        this.selectDirection(direction, false);
      }
    }

    close() {
      this.overlay.hidden = true;
      this.unlockPageScroll();
      this.lastFocused?.focus?.();
    }

    onKeydown(event) {
      if (this.overlay.hidden || event.key !== 'Escape') return;
      event.preventDefault();
      this.close();
    }

    build() {
      if (this.dataset.built === 'true') {
        this.syncExtrasFromProductPage();
        this.ensureRequiredSelections();
        this.renderSummary();
        return;
      }
      this.dataset.built = 'true';
      this.source = this.findMaterialSource();
      this.buildMaterials();
      this.buildDirections();
      this.buildExtras();
      this.selectDefaults();
    }

    findMaterialSource() {
      const forms = Array.from(document.querySelectorAll('.material-sample-form'));
      return forms.find((form) => form.dataset.productTitle === this.dataset.productTitle) || forms[0] || null;
    }

    getCurrentVariant() {
      const id = Number(this.form?.querySelector('[name="id"]')?.value || 0);
      return (this.productData.variants || []).find((variant) => Number(variant.id) === id)
        || (this.productData.variants || []).find((variant) => variant.available)
        || null;
    }

    variantImageSource(variant) {
      const source = variant?.featured_media?.preview_image?.src
        || variant?.featured_image?.src
        || (typeof variant?.featured_image === 'string' ? variant.featured_image : '');
      if (!source) return '';
      return source.startsWith('//') ? `${window.location.protocol}${source}` : source;
    }

    findPreferredOriginalVariant(preferredDirection = '') {
      const variants = (this.productData.variants || []).filter((variant) => this.variantImageSource(variant));
      const current = this.getCurrentVariant();
      if (!variants.length) return current;

      const materialIndex = this.optionIndex(/^(material|bezug|bezugsstoff|stoffart|lederart)$/);
      const directionIndex = this.optionIndex(/^(ausrichtung|ottomane|ecke|kurze seite|lange seite)$/);
      const currentMaterial = this.normalize(current?.options?.[materialIndex]);
      const requestedDirection = this.normalize(preferredDirection);
      const currentDirection = requestedDirection || this.normalize(current?.options?.[directionIndex]);
      const directionVariants = directionIndex >= 0 && currentDirection
        ? variants.filter((variant) => this.normalize(variant.options?.[directionIndex]) === currentDirection)
        : variants;
      const eligibleVariants = directionVariants.length ? directionVariants : variants;
      const isBlackWhite = (value) => {
        const normalized = this.normalize(value);
        return /(^| )schwarz( |$)/u.test(normalized) && /(^| )weiss( |$)/u.test(normalized);
      };
      const isBlackMainWhiteAccent = (value) => {
        const normalized = this.normalize(value);
        const blackIndex = normalized.indexOf('schwarz');
        const whiteIndex = normalized.indexOf('weiss');
        return blackIndex >= 0 && whiteIndex >= 0 && blackIndex < whiteIndex;
      };
      const isBlack = (value) => this.normalize(value) === 'schwarz';
      const ranked = eligibleVariants.map((variant, index) => {
        const optionValues = Array.isArray(variant.options) ? variant.options : [];
        const joinedOptions = optionValues.join(' ');
        let colorPriority = 0;
        if (this.dataset.colorMode === 'zweifarbig' && isBlackMainWhiteAccent(joinedOptions)) colorPriority = 400;
        else if (this.dataset.colorMode === 'zweifarbig' && isBlackWhite(joinedOptions)) colorPriority = 300;
        else if (optionValues.some(isBlack)) colorPriority = 200;
        if (!colorPriority) return null;

        const materialMatch = materialIndex >= 0
          && (this.state?.material
            ? this.materialMatchesVariant(this.state.material, variant.options?.[materialIndex])
            : this.normalize(variant.options?.[materialIndex]) === currentMaterial);
        const directionMatch = directionIndex >= 0
          && this.normalize(variant.options?.[directionIndex]) === currentDirection;
        return {
          variant,
          score: colorPriority + (materialMatch ? 20 : 0) + (directionMatch ? 10 : 0) + (variant.available ? 2 : 0) - (index / 10000)
        };
      }).filter(Boolean).sort((left, right) => right.score - left.score);

      return ranked[0]?.variant || current || variants[0];
    }

    findProductReferenceImages(sourceVariant) {
      if (!sourceVariant || !this.usesProductDirectionSource()) return null;
      const variants = (this.productData.variants || []).filter((variant) => this.variantImageSource(variant));
      const materialIndex = this.optionIndex(/^(material|bezug|bezugsstoff|stoffart|lederart)$/);
      const directionIndex = this.optionIndex(/^(ausrichtung|ottomane|ecke|kurze seite|lange seite)$/);
      const colorIndex = this.optionIndex(/^(farbe|bezugsfarbe|color)$/);
      const sourceMaterial = this.normalize(sourceVariant.options?.[materialIndex]);
      const sourceDirection = this.normalize(sourceVariant.options?.[directionIndex]);
      const eligible = variants.filter((variant) => directionIndex < 0
        || !sourceDirection
        || this.normalize(variant.options?.[directionIndex]) === sourceDirection);
      const handle = this.normalize(this.dataset.productHandle || '');

      if (handle.includes('wave')) {
        const splitColors = (value) => String(value || '')
          .split(/\s*[-–—/]\s*/u)
          .map((part) => this.normalize(part))
          .filter(Boolean)
          .slice(0, 2);
        const sourceColors = splitColors(sourceVariant.options?.[colorIndex]);
        if (sourceColors.length !== 2) return null;
        const ranked = eligible
          .filter((variant) => Number(variant.id) !== Number(sourceVariant.id))
          .map((variant, index) => {
            const colors = splitColors(variant.options?.[colorIndex]);
            if (colors.length !== 2) return null;
            const materialMatch = materialIndex >= 0
              && this.normalize(variant.options?.[materialIndex]) === sourceMaterial;
            return {
              variant,
              colors,
              score: (materialMatch ? 100 : 0) + (variant.available ? 10 : 0) - (index / 10000)
            };
          })
          .filter(Boolean);
        const mainVariant = ranked
          .filter((entry) => entry.colors[1] === sourceColors[1] && entry.colors[0] !== sourceColors[0])
          .sort((left, right) => right.score - left.score)[0]?.variant || null;
        const accentVariant = (ranked
          .filter((entry) => entry.colors[0] === sourceColors[0] && entry.colors[1] !== sourceColors[1])
          .sort((left, right) => right.score - left.score)[0]
          || ranked
            .filter((entry) => entry.colors[1] !== sourceColors[1])
            .sort((left, right) => right.score - left.score)[0])?.variant || null;
        const accent = this.variantImageSource(accentVariant);
        const main = this.variantImageSource(mainVariant);
        const source = this.variantImageSource(sourceVariant);
        if (!accent || !main || accent === main || accent === source || main === source) return null;
        return { accent, main, mode: 'wave-product-reference-pixelmask-v1' };
      }

      const findColorReference = (requiredColors) => eligible
        .map((variant, index) => {
          const normalizedOptions = this.normalize((variant.options || []).join(' '));
          if (!requiredColors.every((color) => new RegExp(`(^| )${color}( |$)`, 'u').test(normalizedOptions))) return null;
          const materialMatch = materialIndex >= 0
            && this.normalize(variant.options?.[materialIndex]) === sourceMaterial;
          return { variant, score: (materialMatch ? 100 : 0) + (variant.available ? 10 : 0) - (index / 10000) };
        })
        .filter(Boolean)
        .sort((left, right) => right.score - left.score)[0]?.variant || null;

      const accentVariant = findColorReference(['schwarz', 'pink']);
      const mainVariant = findColorReference(['rot', 'schwarz']);
      const accent = this.variantImageSource(accentVariant);
      const main = this.variantImageSource(mainVariant);
      if (!accent || !main || accent === main) return null;
      return { accent, main };
    }

    splitVariantColors(value) {
      return String(value || '')
        .split(/\s*[-–—/]\s*/u)
        .map((part) => this.normalize(part))
        .filter(Boolean)
        .slice(0, 2);
    }

    colorMatchesVariantPart(color, part) {
      const target = this.normalize(part);
      if (!color || !target) return false;
      return [color.label, color.backendName]
        .map((value) => this.normalize(value))
        .filter(Boolean)
        .some((value) => value === target || value.includes(target) || target.includes(value));
    }

    findExactConfiguredVariant(direction = this.state?.direction) {
      if (!this.state?.material || !this.state?.main) return null;
      if (this.isTwoColorProduct() && !this.state.singleColor && !this.state.accent) return null;

      const materialIndex = this.optionIndex(/^(material|bezug|bezugsstoff|stoffart|lederart)$/);
      const directionIndex = this.optionIndex(/^(ausrichtung|ottomane|ecke|kurze seite|lange seite)$/);
      const colorIndex = this.optionIndex(/^(farbe|bezugsfarbe|color)$/);
      if (colorIndex < 0) return null;

      const requestedDirection = this.normalize(direction);
      return (this.productData.variants || []).find((variant) => {
        if (!this.variantImageSource(variant)) return false;
        if (materialIndex >= 0 && !this.materialMatchesVariant(this.state.material, variant.options?.[materialIndex])) return false;
        if (directionIndex >= 0 && requestedDirection
          && this.normalize(variant.options?.[directionIndex]) !== requestedDirection) return false;

        const parts = this.splitVariantColors(variant.options?.[colorIndex]);
        if (!parts.length || !this.colorMatchesVariantPart(this.state.main, parts[0])) return false;
        if (!this.isTwoColorProduct() || this.state.singleColor) return parts.length === 1;
        return parts.length > 1 && this.colorMatchesVariantPart(this.state.accent, parts[1]);
      }) || null;
    }

    availableDirections() {
      if (this.directionIndex < 0) return [this.state.direction || ''];
      const values = [...new Set((this.productData.variants || [])
        .map((variant) => variant.options?.[this.directionIndex])
        .filter(Boolean))];
      return values.length ? values : [this.state.direction || ''];
    }

    previewFromShopifyVariant(variant, direction) {
      const image = this.variantImageSource(variant);
      const sourceDirection = this.directionIndex >= 0 ? variant.options?.[this.directionIndex] : direction;
      return {
        cacheKey: this.previewCacheKeyFor(direction, variant),
        image,
        cartImage: image,
        altText: `${this.dataset.productTitle || 'Sofa'} – ${variant.title || 'Produktbild'}`,
        sourceVariant: variant,
        sourceDirection,
        exactShopify: true
      };
    }

    applyOriginalSourceImage() {
      const image = this.querySelector('.sofa-configurator__image');
      const source = this.variantImageSource(this.originalSourceVariant);
      if (!image || !source) return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = source;
    }

    usesProductDirectionSource() {
      const handle = this.normalize(this.dataset.productHandle || '');
      return SOFA_CONFIGURATOR_PRODUCT_DIRECTION_SOURCE_FAMILIES.some((family) => handle.includes(family));
    }

    applyOriginalSourceForDirection(direction) {
      if (!this.usesProductDirectionSource() || this.directionIndex < 0 || !direction) return false;
      const variant = this.findPreferredOriginalVariant(direction);
      const variantDirection = variant?.options?.[this.directionIndex] || '';
      if (this.normalize(variantDirection) !== this.normalize(direction)) return false;

      this.originalSourceVariant = variant;
      this.sourceDirection = variantDirection;
      this.applyOriginalSourceImage();
      this.originalImage = null;
      this.captureOriginalImage(true);
      if (this.restorePreviewButton) this.restorePreviewButton.hidden = true;
      if (this.previewDisclaimer) this.previewDisclaimer.hidden = true;
      if (this.imageNote) {
        this.imageNote.textContent = 'Originalbild – die gewählte individuelle Farbkombination ist noch nicht dargestellt.';
        this.imageNote.classList.remove('is-generated');
      }
      return true;
    }

    getMainSku() {
      const variantSku = String((this.productData.variants || []).find((variant) => variant.sku)?.sku || this.getCurrentVariant()?.sku || '').trim();
      return variantSku.replace(/\.\d+[a-z]*$/iu, '') || variantSku;
    }

    optionIndex(pattern) {
      return (this.productData.options || []).findIndex((name) => pattern.test(this.normalize(name)));
    }

    buildMaterials() {
      const sourceButtons = Array.from(this.source?.querySelectorAll('.material-sample-form__material-type') || []);
      const entries = sourceButtons.map((button) => ({
        key: button.dataset.materialType || this.normalize(button.textContent),
        sourceKey: button.dataset.materialType || this.normalize(button.textContent),
        name: button.querySelector('.material-sample-form__material-type-name')?.textContent.trim() || button.textContent.trim(),
        image: button.querySelector('img')?.currentSrc || button.querySelector('img')?.src || ''
      }));

      const materialIndex = this.optionIndex(/^(material|bezug|bezugsstoff|stoffart|lederart)$/);
      const values = [...new Set((this.productData.variants || []).map((variant) => variant.options?.[materialIndex]).filter(Boolean))];
      values.forEach((value) => {
        if (entries.some((entry) => this.materialMatchesVariant(entry, value))) return;
        const normalizedValue = this.normalize(value);
        const reference = entries.find((entry) => normalizedValue.includes('leder') && this.normalize(entry.name).includes('echtleder'))
          || entries.find((entry) => normalizedValue.includes('leder') && this.normalize(entry.name).includes('kunstleder'))
          || entries[0];
        entries.push({
          key: `variant-${normalizedValue.replace(/\s+/gu, '-')}`,
          sourceKey: reference?.sourceKey || '',
          name: value,
          image: reference?.image || ''
        });
      });

      if (!entries.length) {
        const currentMaterial = this.getCurrentVariant()?.options?.[materialIndex] || 'Standardmaterial';
        entries.push({
          key: `standard-${this.normalize(currentMaterial).replace(/\s+/gu, '-')}`,
          sourceKey: '',
          name: currentMaterial,
          image: ''
        });
      }

      this.materials = entries;
      this.materialGrid.innerHTML = '';
      entries.forEach((entry) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sofa-configurator__material';
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', 'false');
        button.dataset.key = entry.key;
        const swatch = document.createElement('span');
        swatch.className = 'sofa-configurator__material-swatch';
        if (entry.image) {
          const image = document.createElement('img');
          image.src = entry.image;
          image.alt = entry.name;
          image.loading = 'lazy';
          swatch.appendChild(image);
        }
        const label = document.createElement('span');
        label.className = 'sofa-configurator__material-label';
        label.textContent = entry.name;
        button.append(swatch, label);
        button.addEventListener('click', () => this.selectMaterial(entry));
        this.materialGrid.appendChild(button);
      });
    }

    buildDirections() {
      const index = this.optionIndex(/^(ausrichtung|ottomane|ecke|kurze seite|lange seite)$/);
      if (index < 0) return;
      const values = [...new Set((this.productData.variants || []).map((variant) => variant.options?.[index]).filter(Boolean))];
      if (values.length < 2) return;
      this.directionIndex = index;
      this.sourceDirection = this.originalSourceVariant?.options?.[index]
        || this.getCurrentVariant()?.options?.[index]
        || values[0];
      this.directionStep.hidden = false;
      values.forEach((value) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sofa-configurator__choice';
        button.textContent = value;
        button.dataset.value = value;
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', 'false');
        button.addEventListener('click', () => this.selectDirection(value));
        this.directionGrid.appendChild(button);
      });
    }

    buildExtras() {
      const sourceInputs = Array.from(document.querySelectorAll('.sofa-extras__input:not([data-sofa-configurator-surcharge])'));
      if (!sourceInputs.length) return;
      this.extrasStep.hidden = false;
      sourceInputs.forEach((input) => {
        const sourceCard = input.closest('.sofa-extras__option');
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sofa-configurator__extra';
        button.dataset.variantId = input.value;
        button.dataset.exclusiveGroup = input.dataset.exclusiveGroup || '';
        button.dataset.price = input.dataset.price || '0';
        button.dataset.label = input.dataset.label || '';
        button.dataset.sku = input.dataset.sku || '';
        button.setAttribute('aria-pressed', String(input.checked));
        const sourceImage = sourceCard?.querySelector('img');
        if (sourceImage) {
          const image = sourceImage.cloneNode(true);
          image.removeAttribute('class');
          button.dataset.image = sourceImage.currentSrc || sourceImage.src || '';
          button.appendChild(image);
        }
        const label = document.createElement('span');
        label.textContent = input.dataset.label || '';
        const price = document.createElement('small');
        price.textContent = sourceCard?.querySelector('.sofa-extras__price')?.textContent.trim() || '';
        button.append(label, price);
        button.disabled = input.disabled;
        button.addEventListener('click', () => this.toggleExtra(button));
        this.extrasGrid.appendChild(button);
      });
      this.syncExtrasFromProductPage();
    }

    selectDefaults() {
      const variant = this.getCurrentVariant();
      const materialIndex = this.optionIndex(/^(material|bezug|bezugsstoff|stoffart|lederart)$/);
      const currentMaterial = variant?.options?.[materialIndex] || '';
      const material = this.materials.find((entry) => this.materialMatchesVariant(entry, currentMaterial)) || this.materials[0];
      if (material) this.selectMaterial(material, false);

      if (this.directionIndex >= 0) {
        this.selectDirection(variant?.options?.[this.directionIndex] || this.directionGrid.querySelector('button')?.dataset.value, false);
      }

      const colorIndex = this.optionIndex(/^(farbe|bezugsfarbe|color)$/);
      const currentColor = variant?.options?.[colorIndex] || '';
      const colorParts = currentColor.split(/\s*[-/]\s*/).filter(Boolean);
      if (colorParts[0]) this.selectClosestColor('main', colorParts[0]);
      if (colorParts[1]) this.selectClosestColor('accent', colorParts[1]);
      if (!colorParts[1] && !this.supportsFabricAccentOptions() && this.state.main) {
        this.selectSingleColor();
      } else if (!this.state.accent && this.state.main) {
        if (this.supportsFabricAccentOptions() && this.accentColors?.[0]) this.selectColor('accent', this.accentColors[0]);
        else this.selectSingleColor();
      }
      this.ensureRequiredSelections();
      this.renderSummary();
    }

    selectMaterial(entry, resetColors = true) {
      this.invalidatePreview();
      this.state.material = entry;
      this.materialGrid.querySelectorAll('button').forEach((button) => {
        button.setAttribute('aria-checked', String(button.dataset.key === entry.key));
      });
      if (resetColors) {
        this.state.main = null;
        this.state.accent = null;
        this.state.singleColor = false;
        this.singleColorButton.classList.remove('is-selected');
      }
      this.renderColors(entry.sourceKey || entry.key);
      if (this.usesProductDirectionSource()) {
        const sourceVariant = this.findPreferredOriginalVariant(this.state.direction || '');
        if (sourceVariant) {
          this.originalSourceVariant = sourceVariant;
          this.applyOriginalSourceImage();
          this.captureOriginalImage(true);
        }
      }
      this.renderSummary();
      this.refreshConfiguredPreview({ quiet: true });
    }

    getSourceColors(materialKey) {
      const group = Array.from(this.source?.querySelectorAll('.material-sample-form__color-group') || [])
        .find((item) => item.dataset.materialType === materialKey);
      return Array.from(group?.querySelectorAll('.material-sample-form__color') || []).map((button) => ({
        id: button.dataset.colorId || this.normalize(button.dataset.colorBackendName || button.dataset.colorLabel),
        label: button.dataset.colorLabel || '',
        backendName: button.dataset.colorBackendName || button.dataset.colorLabel || '',
        code: button.dataset.colorCode || '',
        image: button.dataset.colorImageUrl || button.querySelector('img')?.currentSrc || button.querySelector('img')?.src || ''
      }));
    }

    getFabricAccentSource(key = this.state.accentMaterialKey || 'kunstleder') {
      return this.fabricAccentSources?.querySelector(`[data-accent-material-source="${CSS.escape(key)}"]`) || null;
    }

    getFabricAccentColors(key = this.state.accentMaterialKey || 'kunstleder') {
      const source = this.getFabricAccentSource(key);
      return Array.from(source?.querySelectorAll('[data-color-id]') || []).map((item) => ({
        id: item.dataset.colorId || this.normalize(item.dataset.colorBackendName || item.dataset.colorLabel),
        label: item.dataset.colorLabel || '',
        backendName: item.dataset.colorBackendName || item.dataset.colorLabel || '',
        code: item.dataset.colorCode || '',
        image: item.dataset.colorImageUrl || ''
      }));
    }

    usesLeatherAccentPalette() {
      return this.supportsFabricAccentOptions() && this.state.accentMaterialKey !== 'fabric' && this.getFabricAccentColors().length > 0;
    }

    isTwoColorProduct() {
      return this.dataset.colorMode === 'zweifarbig';
    }

    supportsFabricAccentOptions() {
      return this.isTwoColorProduct()
        && ['sofa', 'coffee-table'].includes(this.dataset.productKind)
        && this.isFabricMaterial(this.state.material);
    }

    isFabricMaterial(material) {
      const value = this.normalize(`${material?.key || ''} ${material?.name || ''}`);
      return /(stoff|mikrofaser|mineva|altara|wildleder|samt|velvet|boucle|cord|chenille|webstoff|flachgewebe)/u.test(value)
        && !/(kunstleder|ledermix|echtleder|buffelleder|bueffelleder)/u.test(value);
    }

    renderColors(materialKey) {
      this.mainColors = this.getSourceColors(materialKey);
      if (!this.isTwoColorProduct()) {
        this.state.accentMaterialKey = null;
        this.state.singleColor = true;
        this.state.accent = null;
        this.accentColors = [];
        this.colors = this.mainColors;
        if (this.accentStep) this.accentStep.hidden = true;
        if (this.singleColorButton) {
          this.singleColorButton.hidden = true;
          this.singleColorButton.classList.remove('is-selected');
        }
        if (this.accentGrid) {
          this.accentGrid.hidden = true;
          this.accentGrid.innerHTML = '';
        }
        if (this.accentMaterialOptions) {
          this.accentMaterialOptions.hidden = true;
          this.accentMaterialOptions.innerHTML = '';
        }
        if (this.accentMaterialNote) this.accentMaterialNote.hidden = true;
        this.mainGrid.innerHTML = '';
        this.mainColors.forEach((color) => this.mainGrid.appendChild(this.createColorButton('main', color)));
        this.ensureRequiredSelections();
        return;
      }

      if (this.accentStep) this.accentStep.hidden = false;
      const supportsFabricAccent = this.supportsFabricAccentOptions();
      if (supportsFabricAccent && !this.state.accentMaterialKey) this.state.accentMaterialKey = 'kunstleder';
      if (!supportsFabricAccent) this.state.accentMaterialKey = null;
      const usesLeatherAccent = this.usesLeatherAccentPalette();
      const completeFabric = supportsFabricAccent && this.state.accentMaterialKey === 'fabric';
      this.state.singleColor = completeFabric || (!supportsFabricAccent && this.state.singleColor);
      this.accentColors = usesLeatherAccent ? this.getFabricAccentColors() : this.mainColors;
      this.colors = this.mainColors;
      this.singleColorButton.hidden = supportsFabricAccent;
      this.accentGrid.hidden = completeFabric;
      if (this.accentMaterialNote) this.accentMaterialNote.hidden = !supportsFabricAccent;
      this.renderAccentMaterialOptions();
      ['main', 'accent'].forEach((type) => {
        const grid = type === 'main' ? this.mainGrid : this.accentGrid;
        const colors = type === 'main' ? this.mainColors : this.accentColors;
        grid.innerHTML = '';
        colors.forEach((color) => grid.appendChild(this.createColorButton(type, color)));
      });
      this.ensureRequiredSelections();
    }

    ensureRequiredSelections() {
      if (!this.state.material && this.materials?.[0]) {
        this.state.material = this.materials[0];
      }
      if (this.state.material) {
        this.materialGrid?.querySelectorAll('button').forEach((button) => {
          button.setAttribute('aria-checked', String(button.dataset.key === this.state.material.key));
        });
      }

      const completeFabric = this.supportsFabricAccentOptions() && this.state.accentMaterialKey === 'fabric';
      this.ensureColorSelection('main', this.mainColors || []);
      if (completeFabric) {
        this.state.singleColor = true;
        this.state.accent = null;
        this.singleColorButton?.classList.remove('is-selected');
        this.accentGrid?.querySelectorAll('button').forEach((button) => button.setAttribute('aria-checked', 'false'));
      } else if (!this.state.singleColor) {
        this.ensureColorSelection('accent', this.accentColors || []);
      }
    }

    ensureColorSelection(type, colors) {
      const grid = type === 'main' ? this.mainGrid : this.accentGrid;
      const current = this.state[type];
      const selected = colors.find((color) => color.id === current?.id) || colors[0] || null;
      this.state[type] = selected;
      grid?.querySelectorAll('button').forEach((button) => {
        button.setAttribute('aria-checked', String(Boolean(selected) && button.dataset.colorId === selected.id));
      });
    }

    renderAccentMaterialOptions() {
      if (!this.accentMaterialOptions) return;
      const supportsFabricAccent = this.supportsFabricAccentOptions();
      this.accentMaterialOptions.hidden = !supportsFabricAccent;
      this.accentMaterialOptions.innerHTML = '';
      if (!supportsFabricAccent) return;

      const options = [
        { key: 'fabric', label: 'Komplett in Stoff', surcharge: this.getSurcharge('fabric') },
        { key: 'kunstleder', label: 'Kunstleder Premium', price: 0, available: this.getFabricAccentColors('kunstleder').length > 0 },
        { key: 'echtleder', label: 'Echtleder Premium', surcharge: this.getSurcharge('echtleder') },
        { key: 'buffelleder', label: 'Büffelleder Premium', surcharge: this.getSurcharge('buffelleder') }
      ];

      options.forEach((option) => {
        const surchargeReady = option.key === 'kunstleder' || Boolean(option.surcharge?.variantId);
        const paletteReady = option.key === 'fabric' || this.getFabricAccentColors(option.key).length > 0;
        const available = option.available !== false && surchargeReady && paletteReady && option.surcharge?.available !== false;
        const price = Number(option.surcharge?.price || option.price || 0);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sofa-configurator__accent-material-choice';
        button.dataset.key = option.key;
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', String(this.state.accentMaterialKey === option.key));
        button.disabled = !available;
        button.innerHTML = `<strong>${this.escape(option.label)}</strong><small>${price > 0 ? `+ ${this.formatMoney(price)}` : 'ohne Aufpreis'}</small>`;
        button.addEventListener('click', () => this.selectAccentMaterial(option.key));
        this.accentMaterialOptions.appendChild(button);
      });
    }

    selectAccentMaterial(key) {
      if (!this.supportsFabricAccentOptions() || this.state.accentMaterialKey === key) return;
      this.invalidatePreview();
      this.state.accentMaterialKey = key;
      this.state.singleColor = key === 'fabric';
      this.state.accent = null;
      this.renderColors(this.state.material.sourceKey || this.state.material.key);
      this.ensureRequiredSelections();
      this.renderSummary();
      this.refreshConfiguredPreview({ quiet: true });
    }

    getSurcharge(key = this.state.accentMaterialKey) {
      const source = this.surchargeSources?.querySelector(`[data-product-kind="${CSS.escape(this.dataset.productKind || '')}"][data-surcharge-key="${CSS.escape(key || '')}"]`);
      if (!source) return null;
      return {
        key,
        variantId: Number(source.dataset.variantId || 0),
        price: Number(source.dataset.price || 0),
        sku: source.dataset.sku || '',
        label: source.dataset.label || '',
        available: source.dataset.available !== 'false'
      };
    }

    getSelectedSurcharge() {
      if (!this.supportsFabricAccentOptions() || this.state.accentMaterialKey === 'kunstleder') return null;
      return this.getSurcharge(this.state.accentMaterialKey);
    }

    getAccentMaterialName() {
      if (this.supportsFabricAccentOptions() && this.state.accentMaterialKey === 'fabric') return this.state.material?.name || '';
      return this.getFabricAccentSource()?.dataset.materialName || this.state.material?.name || '';
    }

    createColorButton(type, color) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'sofa-configurator__color';
      button.dataset.colorId = color.id;
      button.dataset.searchText = this.normalize(`${color.label} ${color.backendName} ${color.code}`);
      button.setAttribute('role', 'radio');
      button.setAttribute('aria-checked', 'false');
      const swatch = document.createElement('span');
      swatch.className = 'sofa-configurator__color-swatch';
      if (color.image) {
        const image = document.createElement('img');
        image.src = color.image.startsWith('//') ? `${window.location.protocol}${color.image}` : color.image;
        image.alt = `${color.label} – ${color.code || color.backendName}`;
        image.loading = 'lazy';
        swatch.appendChild(image);
      }
      const label = document.createElement('span');
      label.className = 'sofa-configurator__color-label';
      label.textContent = color.label;
      if (color.code) {
        const code = document.createElement('span');
        code.className = 'sofa-configurator__color-code';
        code.textContent = color.code;
        label.appendChild(code);
      }
      button.append(swatch, label);
      button.addEventListener('click', () => this.selectColor(type, color));
      return button;
    }

    selectColor(type, color) {
      this.invalidatePreview();
      this.state[type] = color;
      if (type === 'accent') {
        this.state.singleColor = false;
        this.singleColorButton.classList.remove('is-selected');
      }
      const grid = type === 'main' ? this.mainGrid : this.accentGrid;
      grid.querySelectorAll('button').forEach((button) => {
        button.setAttribute('aria-checked', String(button.dataset.colorId === color.id));
      });
      this.renderSummary();
      this.refreshConfiguredPreview({ quiet: true });
    }

    selectClosestColor(type, value) {
      const normalized = this.normalize(value);
      const colors = type === 'accent' ? (this.accentColors || []) : (this.mainColors || this.colors || []);
      const color = colors.find((item) => this.normalize(item.label) === normalized)
        || colors.find((item) => this.normalize(item.backendName).includes(normalized));
      if (color) this.selectColor(type, color);
    }

    selectSingleColor() {
      this.invalidatePreview();
      this.state.singleColor = true;
      this.state.accent = null;
      this.singleColorButton.classList.add('is-selected');
      this.accentGrid.querySelectorAll('button').forEach((button) => button.setAttribute('aria-checked', 'false'));
      this.renderSummary();
      this.refreshConfiguredPreview({ quiet: true });
    }

    selectDirection(value, render = true) {
      if (!value) return;
      const directionChanged = this.state.direction !== value;
      this.state.direction = value;
      this.directionGrid.querySelectorAll('button').forEach((button) => {
        button.setAttribute('aria-checked', String(button.dataset.value === value));
      });
      if (directionChanged) this.refreshConfiguredPreview({ quiet: !render });
      else this.updateImageDirection();
      if (render) this.renderSummary();
    }

    toggleExtra(button) {
      const id = button.dataset.variantId;
      const willSelect = button.getAttribute('aria-pressed') !== 'true';
      if (willSelect && button.dataset.exclusiveGroup) {
        this.extrasGrid.querySelectorAll(`[data-exclusive-group="${button.dataset.exclusiveGroup}"]`).forEach((other) => {
          other.setAttribute('aria-pressed', 'false');
          this.state.extras.delete(other.dataset.variantId);
        });
      }
      button.setAttribute('aria-pressed', String(willSelect));
      if (willSelect) this.state.extras.add(id); else this.state.extras.delete(id);
      this.renderSummary();
    }

    syncExtrasFromProductPage() {
      this.state.extras = new Set(Array.from(document.querySelectorAll('.sofa-extras__input:checked:not([data-sofa-configurator-surcharge])')).map((input) => input.value));
      this.extrasGrid?.querySelectorAll('.sofa-configurator__extra').forEach((button) => {
        button.setAttribute('aria-pressed', String(this.state.extras.has(button.dataset.variantId)));
      });
    }

    filterColors(type, query) {
      const grid = type === 'main' ? this.mainGrid : this.accentGrid;
      const normalized = this.normalize(query);
      let visible = 0;
      grid.querySelectorAll('.sofa-configurator__color').forEach((button) => {
        const show = !normalized || button.dataset.searchText.includes(normalized);
        button.hidden = !show;
        if (show) visible += 1;
      });
      this.querySelector(`[data-no-results="${type}"]`).hidden = visible > 0;
    }

    renderSummary() {
      const fixedSingleColor = !this.isTwoColorProduct();
      const completeFabric = this.supportsFabricAccentOptions() && this.state.accentMaterialKey === 'fabric';
      const accent = fixedSingleColor
        ? 'Einfarbig'
        : (completeFabric ? `Komplett in ${this.state.material?.name || 'Stoff'}` : (this.state.singleColor ? 'einfarbig' : this.state.accent?.label));
      const accentLabel = fixedSingleColor
        ? 'Farbausführung'
        : (completeFabric
        ? 'Ausführung'
        : (this.usesLeatherAccentPalette() ? `Nebenfarbe · ${this.getAccentMaterialName()}` : 'Nebenfarbe'));
      const lines = [
        { label: 'Material', value: this.state.material?.name, image: this.state.material?.image, fallback: 'M' },
        { label: 'Hauptfarbe', value: this.state.main?.label, image: this.state.main?.image, fallback: 'H' },
        { label: accentLabel, value: accent, image: this.state.singleColor ? this.state.main?.image : this.state.accent?.image, fallback: 'N' },
        { label: 'Ausrichtung', value: this.state.direction, fallback: '↔' }
      ].filter((line) => line.value);

      const rows = lines.map((line) => `
        <div class="sofa-configurator__summary-row">
          ${this.summaryThumb(line.image, line.value, line.fallback)}
          <div class="sofa-configurator__summary-copy"><span>${this.escape(line.label)}</span><strong>${this.escape(line.value)}</strong></div>
        </div>
      `);

      const selectedExtras = Array.from(this.state.extras).map((id) => this.extrasGrid?.querySelector(`[data-variant-id="${CSS.escape(id)}"]`)).filter(Boolean);
      const surcharge = this.getSelectedSurcharge();
      const detailRows = selectedExtras.map((button) => `
          <div class="sofa-configurator__summary-extra">
            ${this.summaryThumb(button.dataset.image, button.dataset.label, '+')}
            <div class="sofa-configurator__summary-copy"><span>Extra</span><strong>${this.escape(button.dataset.label)}</strong></div>
            <span class="sofa-configurator__summary-extra-price">${this.formatMoney(Number(button.dataset.price || 0))}</span>
          </div>
        `);
      if (surcharge) {
        detailRows.push(`
          <div class="sofa-configurator__summary-extra">
            ${this.summaryThumb('', surcharge.label, '+')}
            <div class="sofa-configurator__summary-copy"><span>Materialaufpreis</span><strong>${this.escape(surcharge.label)}</strong></div>
            <span class="sofa-configurator__summary-extra-price">${this.formatMoney(surcharge.price)}</span>
          </div>
        `);
      }
      if (detailRows.length) rows.push(`<div class="sofa-configurator__summary-extras">${detailRows.join('')}</div>`);

      this.liveSummary.innerHTML = rows.length ? rows.join('') : '<p class="sofa-configurator__summary-empty">Treffen Sie rechts Ihre Auswahl. Die Zusammenfassung aktualisiert sich automatisch.</p>';

      const variant = this.state.material ? this.resolveBaseVariant() : this.getCurrentVariant();
      const basePrice = Number(variant?.price || 0);
      const extrasPrice = selectedExtras.reduce((sum, button) => sum + Number(button.dataset.price || 0), 0) + Number(surcharge?.price || 0);
      if (this.basePriceOutput) this.basePriceOutput.textContent = this.formatMoney(basePrice);
      if (this.extrasPriceOutput) {
        this.extrasPriceOutput.hidden = extrasPrice <= 0;
        const value = this.extrasPriceOutput.querySelector('strong');
        if (value) value.textContent = `+ ${this.formatMoney(extrasPrice)}`;
      }
      if (this.totalPriceOutput) this.totalPriceOutput.textContent = this.formatMoney(basePrice + extrasPrice);
      this.updatePreviewAvailability();
    }

    async apply(addToCart = false) {
      this.clearError();
      if (!this.form) return this.showError('Das Produktformular wurde nicht gefunden.');
      if (!this.state.material) return this.showError('Bitte wählen Sie ein Material aus.');
      if (!this.state.main) return this.showError('Bitte wählen Sie eine Hauptfarbe aus.');
      if (!this.state.singleColor && !this.state.accent) return this.showError('Bitte wählen Sie eine Nebenfarbe oder „Einfarbig“ aus.');
      if (!this.legalCheckbox?.checked) {
        this.legalCheckbox?.focus();
        return this.showError('Bitte bestätigen Sie den Hinweis zur individuellen Sonderanfertigung und zum Ausschluss des gesetzlichen Widerrufsrechts.');
      }

      const variant = this.resolveBaseVariant();
      if (!variant) return this.showError('Für dieses Material und diese Ausrichtung konnte keine bestellbare Basisvariante gefunden werden.');
      const surcharge = this.getSelectedSurcharge();
      if (this.supportsFabricAccentOptions() && this.state.accentMaterialKey !== 'kunstleder' && (!surcharge?.variantId || surcharge.available === false)) {
        return this.showError('Der passende Materialaufpreis ist noch nicht als verfügbare Shopify-Variante eingerichtet.');
      }
      const properties = {
        'Individuelle Konfiguration': 'Ja',
        'Modell': this.inferModelName(),
        'Form': this.dataset.sofaForm,
        'Bezugswelt': this.dataset.coverWorld,
        'Material': this.state.material.name,
        'Farbmodus': this.isTwoColorProduct() ? 'Zweifarbig' : 'Einfarbig',
        'Material Nebenfarbe': this.isTwoColorProduct() ? this.getAccentMaterialName() : '',
        'Hauptfarbe': this.state.main.label,
        'Nebenfarbe': this.state.accentMaterialKey === 'fabric' ? `${this.state.main.label} (Komplettbezug in Stoff)` : (this.state.singleColor ? `${this.state.main.label} (einfarbig)` : this.state.accent.label),
        'Materialausführung': surcharge?.label || (this.usesLeatherAccentPalette() ? this.getAccentMaterialName() : ''),
        'Ausrichtung': this.state.direction || 'nicht wählbar',
        '_sd_custom_configuration': 'v2',
        '_sd_custom_acknowledged': 'Ja',
        '_sd_main_color_reference': this.formatColorReference(this.state.main),
        '_sd_accent_color_reference': this.state.singleColor ? this.formatColorReference(this.state.main) : this.formatColorReference(this.state.accent),
        '_sd_preview_image': '',
        '_sd_preview_alt': '',
        '_sd_preview_mirrored': ''
      };

      if (addToCart) {
        const added = await this.addConfiguredToCart(variant, properties);
        if (!added) return;
      } else {
        this.syncBaseVariant(variant);
        this.syncExtrasToProductPage();
        this.syncSurchargeToProductPage();
        Object.entries(properties).forEach(([name, value]) => this.setProperty(name, value));
      }

      const savedColor = this.isTwoColorProduct()
        ? `${this.state.main.label} / ${this.state.accentMaterialKey === 'fabric' ? 'Komplettbezug in Stoff' : (this.state.singleColor ? 'einfarbig' : this.state.accent.label)}`
        : `${this.state.main.label} · einfarbig`;
      this.savedText.textContent = `${this.state.material.name} · ${savedColor}${this.state.direction ? ` · ${this.state.direction}` : ''}`;
      this.saved.hidden = false;
      const legacyOpenButton = this.querySelector('.sofa-configurator__open');
      if (legacyOpenButton) legacyOpenButton.hidden = true;
      this.close();
    }

    async addConfiguredToCart(variant, properties) {
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const actionButton = this.querySelector('.sofa-configurator__apply-cart');
      const formData = new FormData(this.form);
      const quantity = Math.max(1, Number(formData.get('quantity') || 1));
      const selectedExtras = Array.from(this.state.extras)
        .map((id) => this.extrasGrid?.querySelector(`[data-variant-id="${CSS.escape(id)}"]`))
        .filter(Boolean);
      const surcharge = this.getSelectedSurcharge();
      const groupId = selectedExtras.length || surcharge ? `sofa-${Date.now()}-${Math.random().toString(36).slice(2, 9)}` : '';
      const mainProperties = Object.fromEntries(
        Object.entries(properties).filter(([, value]) => value !== '')
      );
      if (formData.has('selling_plan')) mainProperties._Anzahlung = 'true';
      if (groupId) mainProperties._sofa_extra_group = groupId;

      const mainItem = { id: Number(variant.id), quantity, properties: mainProperties };
      if (formData.get('selling_plan')) mainItem.selling_plan = Number(formData.get('selling_plan'));
      const extraItems = selectedExtras.map((button) => {
        const extraProperties = {
          _sofa_extra_group: groupId,
          _sofa_extra_item: 'true',
          'Extra für': this.dataset.productTitle
        };
        const sku = button.dataset.sku || '';
        if (variant.title && (sku === 'EXTRA-COUCHTISCH' || sku === 'EXTRA-COUCHTISCH-LED')) {
          extraProperties['Anfertigung wie Sofa'] = variant.title;
        }
        return { id: Number(button.dataset.variantId), quantity, properties: extraProperties };
      }).reverse();

      if (surcharge) {
        extraItems.unshift({
          id: surcharge.variantId,
          quantity,
          properties: {
            _sofa_extra_group: groupId,
            _sofa_extra_item: 'true',
            'Aufpreis für': this.dataset.productTitle,
            'Ausführung': surcharge.label
          }
        });
      }

      const payload = { items: extraItems.concat(mainItem) };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        payload.sections = cart.getSectionsToRender().map((section) => section.id);
        payload.sections_url = window.location.pathname;
      }

      if (actionButton) {
        actionButton.disabled = true;
        actionButton.classList.add('loading');
        actionButton.textContent = 'Wird hinzugefügt …';
      }

      try {
        const result = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload)
        });
        const state = await result.json();
        if (!result.ok || state.status) {
          throw new Error(state.description || state.message || 'Die Konfiguration konnte nicht in den Warenkorb gelegt werden.');
        }

        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sofa-configurator' });
        }
        if (cart && typeof cart.renderContents === 'function') cart.renderContents(state);
        else window.location = window.routes?.cart_url || '/cart';
        return true;
      } catch (error) {
        this.showError(error.message || 'Die Konfiguration konnte nicht in den Warenkorb gelegt werden.');
        return false;
      } finally {
        if (actionButton) {
          actionButton.disabled = false;
          actionButton.classList.remove('loading');
          actionButton.textContent = 'Übernehmen & in den Warenkorb';
        }
      }
    }

    resolveBaseVariant() {
      const variants = (this.productData.variants || []).filter((variant) => variant.available);
      const materialIndex = this.optionIndex(/^(material|bezug|bezugsstoff|stoffart|lederart)$/);
      const current = this.getCurrentVariant();
      let candidates = variants;
      if (materialIndex >= 0) candidates = candidates.filter((variant) => this.materialMatchesVariant(this.state.material, variant.options?.[materialIndex]));
      if (this.directionIndex >= 0 && this.state.direction) candidates = candidates.filter((variant) => variant.options?.[this.directionIndex] === this.state.direction);
      const colorIndex = this.optionIndex(/^(farbe|bezugsfarbe|color)$/);
      return candidates.find((variant) => colorIndex < 0 || variant.options?.[colorIndex] === current?.options?.[colorIndex]) || candidates[0] || null;
    }

    materialMatchesVariant(material, variantValue) {
      const source = this.normalize(`${material?.key || ''} ${material?.name || ''}`);
      const target = this.normalize(variantValue || '');
      if (!target) return false;
      if (/(mikrofaser|mineva|altara|wildleder)/u.test(source)) return target.includes('mikrofaser');
      if (source.includes('kunstleder')) return target.includes('kunstleder');
      if (source.includes('ledermix')) return target.includes('ledermix');
      if (source.includes('buffelleder') || source.includes('bueffelleder')) return target.includes('buffelleder') || target.includes('bueffelleder');
      if (source.includes('echtleder')) return target.includes('echtleder');
      if (/(struktur|hugo|scala|webstoff|flachgewebe)/u.test(source)) return target.includes('struktur') || target.includes('webstoff') || target.includes('flachgewebe');
      if (/(samt|velvet|sunvelvet)/u.test(source)) return target.includes('samt') || target.includes('velvet') || target.includes('mikrofaser');
      if (source.includes('boucle')) return target.includes('boucle') || target.includes('struktur');
      if (source.includes('chenille')) return target.includes('chenille') || target.includes('struktur');
      if (source.includes('cord')) return target.includes('cord') || target.includes('struktur');
      return source.includes(target) || target.includes(source);
    }

    syncBaseVariant(variant) {
      const picker = document.getElementById(`variant-radios-${this.dataset.sectionId}`)
        || document.getElementById(`variant-selects-${this.dataset.sectionId}`);
      if (picker?.syncInputsToVariant && picker?.onVariantChange) {
        picker.syncInputsToVariant(variant);
        picker.onVariantChange();
      }
      const variantInput = this.form.querySelector('[name="id"]');
      if (variantInput) variantInput.value = variant.id;
      const image = this.querySelector('.sofa-configurator__image');
      const imageSource = this.variantImageSource(variant);
      if (image && imageSource) image.src = imageSource;
    }

    syncExtrasToProductPage() {
      document.querySelectorAll('.sofa-extras__input:not([data-sofa-configurator-surcharge])').forEach((input) => {
        const shouldCheck = this.state.extras.has(input.value);
        if (input.checked !== shouldCheck) {
          input.checked = shouldCheck;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    syncSurchargeToProductPage() {
      const extras = Array.from(document.querySelectorAll('sofa-extras'))
        .find((element) => element.dataset.productFormId === this.dataset.productFormId);
      if (!extras) return;

      extras.querySelector('[data-sofa-configurator-surcharge]')?.remove();
      const surcharge = this.getSelectedSurcharge();
      if (surcharge?.variantId && surcharge.available !== false) {
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.hidden = true;
        input.checked = true;
        input.className = 'sofa-extras__input';
        input.value = String(surcharge.variantId);
        input.dataset.sofaConfiguratorSurcharge = 'true';
        input.dataset.price = String(surcharge.price);
        input.dataset.label = surcharge.label;
        input.dataset.sku = surcharge.sku;
        extras.appendChild(input);
      }
      extras.inputs = Array.from(extras.querySelectorAll('.sofa-extras__input'));
      extras.updateSummary?.();
    }

    setProperty(name, value) {
      let input = this.form.querySelector(`[data-sofa-configurator-property="${CSS.escape(name)}"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.dataset.sofaConfiguratorProperty = name;
        input.name = `properties[${name}]`;
        this.form.appendChild(input);
      }
      input.value = value;
    }

    formatColorReference(color) {
      return [color?.backendName, color?.code].filter(Boolean).join(' · ');
    }

    summaryThumb(image, label, fallback) {
      const content = image
        ? `<img src="${this.escape(image)}" alt="${this.escape(label || '')}" loading="lazy">`
        : this.escape(fallback || '•');
      return `<span class="sofa-configurator__summary-thumb" aria-hidden="true">${content}</span>`;
    }

    formatMoney(cents) {
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(Number(cents || 0), this.dataset.moneyFormat);
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Number(cents || 0) / 100);
    }

    selectedExtrasForPdf() {
      return Array.from(this.state.extras)
        .map((id) => this.extrasGrid?.querySelector(`[data-variant-id="${CSS.escape(id)}"]`))
        .filter(Boolean)
        .map((button) => ({ label: button.dataset.label || 'Extra', price: Number(button.dataset.price || 0) }));
    }

    pdfConfiguration() {
      const variant = this.state.material ? this.resolveBaseVariant() : this.getCurrentVariant();
      const extras = this.selectedExtrasForPdf();
      const surcharge = this.getSelectedSurcharge();
      const extrasPrice = extras.reduce((sum, item) => sum + item.price, 0) + Number(surcharge?.price || 0);
      const basePrice = Number(variant?.price || 0);
      const completeFabric = this.supportsFabricAccentOptions() && this.state.accentMaterialKey === 'fabric';
      const image = this.querySelector('.sofa-configurator__image');
      const kindLabels = { sofa: 'Sofa', bed: 'Bett', 'coffee-table': 'Couchtisch' };
      const now = new Date();
      const validUntil = new Date(now);
      validUntil.setDate(validUntil.getDate() + 10);
      const dateToken = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`;
      const sku = this.getMainSku() || variant?.sku || 'OHNE-SKU';
      return {
        title: this.dataset.productTitle || 'Individuelle Konfiguration',
        kind: kindLabels[this.dataset.productKind] || 'Möbelstück',
        model: this.inferModelName(),
        form: this.dataset.sofaForm || 'Nicht angegeben',
        sku,
        material: this.state.material?.name || 'Nicht gewählt',
        colorMode: this.isTwoColorProduct() ? 'Zweifarbig' : 'Einfarbig',
        mainColor: this.state.main?.label || 'Nicht gewählt',
        accentMaterial: this.isTwoColorProduct() ? this.getAccentMaterialName() : 'Entfällt (einfarbig)',
        accentColor: completeFabric
          ? `${this.state.main?.label || ''} (Komplettbezug in Stoff)`
          : (this.state.singleColor ? `${this.state.main?.label || ''} (einfarbig)` : (this.state.accent?.label || 'Nicht gewählt')),
        direction: this.state.direction || 'Nicht wählbar',
        extras,
        surcharge,
        basePrice,
        extrasPrice,
        totalPrice: basePrice + extrasPrice,
        productUrl: this.dataset.productUrl || window.location.href,
        imageSource: image?.currentSrc || image?.src || this.originalImage?.src || '',
        logoSource: this.dataset.logoUrl || '',
        mirrored: image?.classList.contains('is-mirrored') || false,
        generatedPreview: false,
        createdAt: new Intl.DateTimeFormat('de-DE', { dateStyle: 'long' }).format(now),
        validUntil: new Intl.DateTimeFormat('de-DE').format(validUntil),
        offerNumber: `KONFIG-${sku}-${dateToken}`
      };
    }

    loadPdfLibrary() {
      if (window.PDFLib?.PDFDocument) return Promise.resolve(window.PDFLib);
      if (this.pdfLibraryPromise) return this.pdfLibraryPromise;
      this.pdfLibraryPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = this.dataset.pdfLibraryUrl;
        script.async = true;
        script.onload = () => window.PDFLib?.PDFDocument ? resolve(window.PDFLib) : reject(new Error('Die PDF-Bibliothek konnte nicht geladen werden.'));
        script.onerror = () => reject(new Error('Die PDF-Bibliothek konnte nicht geladen werden.'));
        document.head.appendChild(script);
      });
      return this.pdfLibraryPromise;
    }

    async imageAsPngBytes(source, mirrored = false) {
      if (!source) throw new Error('Für das PDF ist kein Produktbild verfügbar.');
      const response = await fetch(this.absoluteUrl(source), { mode: 'cors', credentials: 'omit' });
      if (!response.ok) throw new Error('Das Produktbild konnte für das PDF nicht geladen werden.');
      const sourceBlob = await response.blob();
      let bitmap;
      let objectUrl = '';
      if (typeof createImageBitmap === 'function') {
        bitmap = await createImageBitmap(sourceBlob);
      } else {
        objectUrl = URL.createObjectURL(sourceBlob);
        bitmap = await new Promise((resolve, reject) => {
          const fallbackImage = new Image();
          fallbackImage.onload = () => resolve(fallbackImage);
          fallbackImage.onerror = () => reject(new Error('Das Produktbild konnte für das PDF nicht verarbeitet werden.'));
          fallbackImage.src = objectUrl;
        });
      }
      const bitmapWidth = bitmap.width || bitmap.naturalWidth;
      const bitmapHeight = bitmap.height || bitmap.naturalHeight;
      const scale = Math.min(1, 1500 / bitmapWidth, 1000 / bitmapHeight);
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(bitmapWidth * scale));
      canvas.height = Math.max(1, Math.round(bitmapHeight * scale));
      const context = canvas.getContext('2d');
      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      if (mirrored) {
        context.translate(canvas.width, 0);
        context.scale(-1, 1);
      }
      context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
      bitmap.close?.();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      const png = await new Promise((resolve, reject) => canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error('Das Produktbild konnte nicht in das PDF übernommen werden.')), 'image/png', 0.94));
      return new Uint8Array(await png.arrayBuffer());
    }

    pdfFilename(data) {
      const safe = (value) => String(value || '')
        .normalize('NFD').replace(/[\u0300-\u036f]/gu, '')
        .replace(/[^a-z0-9]+/giu, '-').replace(/^-+|-+$/gu, '');
      return [safe(data.sku), safe(data.model), safe(data.material), safe(data.mainColor), safe(data.accentColor), 'Angebot.pdf'].filter(Boolean).join('-');
    }

    async downloadConfigurationPdf() {
      this.clearError();
      if (!this.state.material) return this.showError('Bitte wählen Sie zuerst ein Material aus.');
      if (!this.state.main) return this.showError('Bitte wählen Sie zuerst eine Hauptfarbe aus.');
      if (!this.state.singleColor && !this.state.accent) return this.showError('Bitte wählen Sie zuerst eine Nebenfarbe aus.');
      const previewWindow = window.open('', '_blank');
      if (!previewWindow) return this.showError('Bitte erlauben Sie Pop-ups, damit die PDF-Vorschau geöffnet werden kann.');
      previewWindow.document.title = 'Angebots-PDF wird erstellt';
      previewWindow.document.body.innerHTML = '<p style="font:16px Arial,sans-serif;padding:32px;color:#171717">Das Angebots-PDF wird erstellt …</p>';
      const originalLabel = this.pdfButton?.textContent || 'Angebots-PDF anzeigen';
      if (this.pdfButton) {
        this.pdfButton.disabled = true;
        this.pdfButton.classList.add('is-loading');
        this.pdfButton.textContent = 'PDF wird erstellt …';
      }
      try {
        const data = this.pdfConfiguration();
        const [PDFLib, imageBytes, logoBytes] = await Promise.all([
          this.loadPdfLibrary(),
          this.imageAsPngBytes(data.imageSource, data.mirrored),
          data.logoSource ? this.imageAsPngBytes(data.logoSource).catch(() => null) : Promise.resolve(null)
        ]);
        const bytes = await this.buildConfigurationPdf(PDFLib, data, imageBytes, logoBytes);
        const filename = this.pdfFilename(data);
        const objectUrl = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
        const previewDocument = previewWindow.document;
        previewDocument.title = `${data.title} – Angebots-PDF`;
        previewDocument.documentElement.lang = 'de';
        previewDocument.head.replaceChildren();
        previewDocument.body.replaceChildren();

        const style = previewDocument.createElement('style');
        style.textContent = 'html,body{height:100%;margin:0;background:#ecebea;color:#171717;font-family:Arial,sans-serif}body{display:flex;flex-direction:column}.pdf-toolbar{display:flex;align-items:center;gap:12px;padding:12px 18px;background:#fff;border-bottom:1px solid #d7d5d2}.pdf-title{min-width:0;margin-right:auto;font-size:15px;font-weight:700;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.pdf-action{appearance:none;border:1px solid #171717;border-radius:6px;background:#fff;color:#171717;padding:10px 16px;font:700 14px Arial,sans-serif;text-decoration:none;cursor:pointer}.pdf-action--primary{background:#171717;color:#fff}.pdf-frame{display:block;width:100%;height:100%;border:0;flex:1}@media(max-width:640px){.pdf-toolbar{flex-wrap:wrap}.pdf-title{width:100%;margin-right:0}.pdf-action{flex:1;text-align:center}}';
        previewDocument.head.append(style);

        const toolbar = previewDocument.createElement('div');
        toolbar.className = 'pdf-toolbar';
        const title = previewDocument.createElement('div');
        title.className = 'pdf-title';
        title.textContent = `${data.title} – Angebots-PDF`;
        const download = previewDocument.createElement('a');
        download.className = 'pdf-action';
        download.href = objectUrl;
        download.download = filename;
        download.textContent = 'Herunterladen';
        const print = previewDocument.createElement('button');
        print.type = 'button';
        print.className = 'pdf-action pdf-action--primary';
        print.textContent = 'Drucken';
        const frame = previewDocument.createElement('iframe');
        frame.className = 'pdf-frame';
        frame.title = 'Vorschau des Angebots-PDFs';
        frame.src = `${objectUrl}#toolbar=1&navpanes=0`;
        print.addEventListener('click', () => {
          try {
            frame.contentWindow?.focus();
            frame.contentWindow?.print();
          } catch (_error) {
            previewWindow.print();
          }
        });
        toolbar.append(title, download, print);
        previewDocument.body.append(toolbar, frame);
        previewWindow.addEventListener('beforeunload', () => URL.revokeObjectURL(objectUrl), { once: true });
      } catch (error) {
        previewWindow.close();
        this.showError(error.message || 'Das PDF-Datenblatt konnte nicht erstellt werden.');
      } finally {
        if (this.pdfButton) {
          this.pdfButton.disabled = false;
          this.pdfButton.classList.remove('is-loading');
          this.pdfButton.textContent = originalLabel;
        }
      }
    }

    async buildConfigurationPdf(PDFLib, data, imageBytes, logoBytes = null) {
      const { PDFDocument, StandardFonts, rgb } = PDFLib;
      const document = await PDFDocument.create();
      document.setTitle(`${data.title} – Konfigurationsangebot`);
      document.setAuthor('Sofa Dreams');
      document.setSubject('Angebot für eine individuelle Möbelkonfiguration');
      document.setKeywords(['Sofa Dreams', data.kind, data.model, data.sku]);
      const regular = await document.embedFont(StandardFonts.Helvetica);
      const bold = await document.embedFont(StandardFonts.HelveticaBold);
      const productImage = await document.embedPng(imageBytes);
      let logo = null;
      if (logoBytes) {
        try { logo = await document.embedPng(logoBytes); } catch (_error) { logo = null; }
      }
      const ink = rgb(0.075, 0.075, 0.075);
      const muted = rgb(0.39, 0.39, 0.39);
      const line = rgb(0.87, 0.86, 0.84);
      const warm = rgb(0.965, 0.95, 0.925);
      const soft = rgb(0.975, 0.97, 0.96);
      const accent = rgb(0.78, 0.31, 0.08);
      const green = rgb(0.13, 0.48, 0.32);
      const white = rgb(1, 1, 1);
      const margin = 38;
      const width = 595.28 - (margin * 2);
      const clean = (value) => String(value ?? '').replace(/[\r\n]+/gu, ' ').trim();
      const money = (cents) => `${new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(cents || 0) / 100)} EUR`;
      const wrap = (value, font, size, maxWidth) => {
        const words = clean(value).split(/\s+/u).filter(Boolean);
        const rows = [];
        let current = '';
        words.forEach((word) => {
          const candidate = current ? `${current} ${word}` : word;
          if (current && font.widthOfTextAtSize(candidate, size) > maxWidth) { rows.push(current); current = word; }
          else current = candidate;
        });
        if (current) rows.push(current);
        return rows;
      };
      const drawLines = (targetPage, value, x, y, maxWidth, options = {}) => {
        const font = options.font || regular;
        const size = options.size || 8;
        const leading = options.leading || size * 1.25;
        wrap(value, font, size, maxWidth).slice(0, options.maxLines || 3).forEach((row, index) => {
          targetPage.drawText(row, { x, y: y - (index * leading), size, font, color: options.color || ink });
        });
      };
      const drawRight = (targetPage, value, right, y, options = {}) => {
        const font = options.font || regular;
        const size = options.size || 8;
        const text = clean(value);
        targetPage.drawText(text, { x: right - font.widthOfTextAtSize(text, size), y, size, font, color: options.color || ink });
      };
      const drawLogo = (targetPage) => {
        if (logo) {
          const fittedLogo = logo.scaleToFit(230, 42);
          targetPage.drawImage(logo, { x: margin, y: 780, width: fittedLogo.width, height: fittedLogo.height });
        } else {
          targetPage.drawText('SOFA DREAMS', { x: margin, y: 795, size: 20, font: bold, color: ink });
        }
      };
      const drawFooter = (targetPage, pageNumber) => {
        targetPage.drawLine({ start: { x: margin, y: 35 }, end: { x: margin + width, y: 35 }, thickness: 0.8, color: line });
        targetPage.drawText('Sofa Dreams | Fennstrasse 1 | 12439 Berlin', { x: margin, y: 20, size: 6.8, font: regular, color: muted });
        drawRight(targetPage, `Seite ${pageNumber}`, margin + width, 20, { size: 6.8, color: muted });
      };

      const coverPage = document.addPage([595.28, 841.89]);
      drawLogo(coverPage);
      drawRight(coverPage, 'KONFIGURATIONSANGEBOT', margin + width, 795, { font: bold, size: 8.2, color: accent });
      drawRight(coverPage, data.offerNumber, margin + width, 780, { size: 6.7, color: muted });
      coverPage.drawText(`Ein ${clean(data.kind)} nach`, { x: margin, y: 725, size: 28, font: bold, color: ink });
      coverPage.drawText('Ihrer Vorstellung', { x: margin, y: 690, size: 28, font: bold, color: ink });
      coverPage.drawText('Konfiguration, Preis und alle wichtigen Hinweise auf einen Blick', { x: margin, y: 662, size: 9.5, font: regular, color: muted });
      coverPage.drawRectangle({ x: margin, y: 315, width, height: 315, color: warm });
      coverPage.drawRectangle({ x: margin + 62, y: 330, width: width - 124, height: 285, color: white, borderColor: line, borderWidth: 0.7 });
      const fitted = productImage.scaleToFit(width - 146, 263);
      coverPage.drawImage(productImage, { x: margin + ((width - fitted.width) / 2), y: 341 + ((263 - fitted.height) / 2), width: fitted.width, height: fitted.height });
      drawLines(coverPage, data.title, margin, 280, width, { font: bold, size: 17, leading: 19, maxLines: 2 });
      const completeFabric = /Komplettbezug in Stoff/iu.test(data.accentColor);
      const coverSelection = data.colorMode === 'Zweifarbig'
        ? (completeFabric
          ? `${clean(data.material)} | ${clean(data.mainColor)} | Komplettbezug in Stoff | Ausrichtung ${clean(data.direction)}`
          : `${clean(data.material)} | ${clean(data.mainColor)} mit ${clean(data.accentColor)} | Ausrichtung ${clean(data.direction)}`)
        : `${clean(data.material)} | ${clean(data.mainColor)} | Ausrichtung ${clean(data.direction)}`;
      coverPage.drawText(coverSelection, { x: margin, y: 242, size: 8.4, font: regular, color: muted });
      coverPage.drawLine({ start: { x: margin, y: 218 }, end: { x: margin + width, y: 218 }, thickness: 0.8, color: line });
      coverPage.drawText('Gesamtpreis inkl. MwSt.', { x: margin, y: 190, size: 8, font: bold, color: muted });
      coverPage.drawText(money(data.totalPrice), { x: margin, y: 156, size: 26, font: bold, color: ink });
      drawRight(coverPage, 'Voraussichtliche Lieferzeit', margin + width, 190, { font: bold, size: 8, color: muted });
      drawRight(coverPage, 'ca. 8 Wochen', margin + width, 162, { font: bold, size: 18, color: green });
      coverPage.drawText(`Gültig bis ${clean(data.validUntil)}`, { x: margin, y: 91, size: 7.5, font: regular, color: muted });
      drawRight(coverPage, 'Sofa Dreams Berlin', margin + width, 91, { size: 7.5, color: muted });
      drawFooter(coverPage, 1);

      const detailsPage = document.addPage([595.28, 841.89]);
      drawLogo(detailsPage);
      drawRight(detailsPage, 'DETAILS ZUM ANGEBOT', margin + width, 795, { font: bold, size: 8.2, color: accent });
      detailsPage.drawText('Konfiguration', { x: margin, y: 742, size: 19, font: bold, color: ink });
      detailsPage.drawText('Die gewählte Zusammenstellung bildet die Grundlage für die Bestellung.', { x: margin, y: 720, size: 8.5, font: regular, color: muted });

      const configurationRows = [
        ['Produkt', data.title],
        ['Haupt-SKU', data.sku],
        ['Bezug', data.material],
        ['Hauptfarbe', data.mainColor],
        ...(data.colorMode === 'Zweifarbig' ? [['Nebenmaterial', data.accentMaterial], ['Nebenfarbe / Ausführung', data.accentColor]] : [['Farbausführung', data.accentColor]]),
        ['Ausrichtung', data.direction]
      ];
      let configY = 690;
      configurationRows.forEach(([label, value], index) => {
        if (index % 2 === 0) detailsPage.drawRectangle({ x: margin, y: configY - 19, width, height: 27, color: soft });
        detailsPage.drawText(clean(label), { x: margin + 12, y: configY - 9, size: 7.8, font: bold, color: muted });
        drawLines(detailsPage, value, margin + 140, configY - 9, width - 152, { size: 8.2, font: index < 2 ? bold : regular, maxLines: 1 });
        configY -= 27;
      });

      const priceTitleY = configY - 5;
      detailsPage.drawText('Preisübersicht', { x: margin, y: priceTitleY, size: 15, font: bold, color: ink });
      const priceRows = [{ label: 'Grundmodell', detail: data.title, price: data.basePrice, prefix: '' }];
      if (data.surcharge) priceRows.push({ label: 'Materialaufpreis', detail: data.surcharge.label, price: data.surcharge.price, prefix: '+' });
      data.extras.forEach((item) => priceRows.push({ label: 'Extra', detail: item.label, price: item.price, prefix: '+' }));
      if (!data.surcharge && !data.extras.length) priceRows.push({ label: 'Aufpreise / Extras', detail: 'Keine zusätzlichen Extras gewählt', included: true });

      let priceY = priceTitleY - 26;
      priceRows.forEach((item, index) => {
        if (index % 2 === 0) detailsPage.drawRectangle({ x: margin, y: priceY - 14, width, height: 25, color: soft });
        detailsPage.drawText(clean(item.label), { x: margin + 10, y: priceY - 5, size: 7.2, font: bold, color: muted });
        drawLines(detailsPage, item.detail, margin + 100, priceY - 5, width - 220, { size: 7.5, maxLines: 1 });
        drawRight(detailsPage, item.included ? 'inklusive' : `${item.prefix}${item.prefix ? ' ' : ''}${money(item.price)}`, margin + width - 10, priceY - 5, { size: 7.8, font: item.prefix ? bold : regular });
        priceY -= 25;
      });
      detailsPage.drawRectangle({ x: margin, y: priceY - 22, width, height: 34, color: warm });
      detailsPage.drawText('Gesamtpreis inkl. MwSt.', { x: margin + 12, y: priceY - 10, size: 9, font: bold, color: ink });
      drawRight(detailsPage, money(data.totalPrice), margin + width - 12, priceY - 10, { size: 13, font: bold });
      detailsPage.drawText('Im Gesamtpreis sind 19 % Mehrwertsteuer enthalten.', { x: margin, y: priceY - 39, size: 6.8, font: regular, color: muted });

      const noteY = Math.max(112, priceY - 68);
      detailsPage.drawText('Lieferung und wichtige Hinweise', { x: margin, y: noteY, size: 11.5, font: bold, color: ink });
      drawLines(detailsPage, 'Voraussichtliche Lieferzeit: ca. 8 Wochen. Buchbare Zusatzleistungen werden nur berechnet, wenn sie in der Konfiguration ausgewählt wurden.', margin, noteY - 18, width, { size: 6.7, leading: 8.2, color: muted, maxLines: 2 });
      const previewNote = data.generatedPreview
        ? 'Das dargestellte Bild ist eine KI-generierte, unverbindliche Farbvorschau. Farben, Flächen und Details können vom tatsächlich gefertigten Möbelstück abweichen. Gewählte Extras werden im Vorschaubild nicht dargestellt.'
        : 'Das dargestellte Bild ist das Originalbild des Produkts. Die gewählte individuelle Farbkombination und gewählte Extras sind darin möglicherweise noch nicht dargestellt.';
      drawLines(detailsPage, previewNote, margin, noteY - 41, width, { size: 6.5, leading: 7.8, color: muted, maxLines: 3 });
      drawLines(detailsPage, 'Für Waren, die nicht vorgefertigt sind und deren Herstellung durch die individuelle Auswahl bestimmt wird, besteht gemäß § 312g Abs. 2 Nr. 1 BGB kein Widerrufsrecht.', margin, noteY - 68, width, { size: 6.6, leading: 8, font: bold, color: ink, maxLines: 3 });
      detailsPage.drawText('Fragen zur Konfiguration: 030 63222230 | info@sofa-dreams.com', { x: margin, y: 54, size: 7.3, font: bold, color: ink });
      drawRight(detailsPage, `Angebot gültig bis ${clean(data.validUntil)}`, margin + width, 54, { size: 6.8, color: muted });
      drawFooter(detailsPage, 2);
      return document.save();
    }

    captureOriginalImage(force = false) {
      if (this.originalImage && !force) return;
      const image = this.querySelector('.sofa-configurator__image');
      if (!image) return;
      const source = image.getAttribute('src') || image.currentSrc || image.src;
      try {
        const hostname = new URL(source, window.location.origin).hostname;
        const trustedSource = hostname === 'cdn.shopify.com'
          || hostname === 'www.sofa-dreams.com'
          || hostname === 'sofa-dreams.com'
          || hostname.endsWith('.myshopify.com');
        if (!trustedSource) return;
      } catch (_error) {
        return;
      }
      this.originalImage = {
        src: source,
        srcAttribute: image.getAttribute('src') || image.src,
        srcset: image.getAttribute('srcset'),
        sizes: image.getAttribute('sizes')
      };
    }

    updatePreviewAvailability() {
      if (this.previewStatus) {
        this.previewStatus.textContent = SOFA_CONFIGURATOR_NO_PREVIEW_MESSAGE;
        this.previewStatus.classList.remove('is-error');
      }
    }

    setupMobilePreviewObserver() {
      if (!this.previewButton || !this.mobilePreviewButton || !('IntersectionObserver' in window)) return;
      const body = this.querySelector('.sofa-configurator__body');
      this.mobilePreviewObserver = new IntersectionObserver(([entry]) => {
        this.mobilePreviewButton.hidden = entry.isIntersecting;
      }, { root: body, threshold: 0.15 });
      this.mobilePreviewObserver.observe(this.previewButton);
    }

    scrollToPreview() {
      this.querySelector('.sofa-configurator__visual-image')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    invalidatePreview() {
      this.currentPreview = null;
      if (!this.restorePreviewButton?.hidden) this.restoreOriginalPreview();
      if (this.previewStatus) {
        this.previewStatus.textContent = SOFA_CONFIGURATOR_NO_PREVIEW_MESSAGE;
        this.previewStatus.classList.remove('is-error');
      }
    }

    activatePreview(preview, options = {}) {
      if (!preview?.image) return false;
      this.currentPreview = preview;
      this.sourceDirection = preview.sourceDirection || this.state.direction || this.sourceDirection;
      if (preview.exactShopify) this.showShopifyProductPreview(preview.image);
      else this.showGeneratedPreview(preview.image);
      if (!options.quiet && this.previewStatus) {
        this.previewStatus.textContent = preview.exactShopify
          ? 'Vorhandenes Shopify-Produktbild geladen – keine KI-Generierung erforderlich.'
          : 'Gespeicherte Vorschau für diese Ausrichtung geladen.';
        this.previewStatus.classList.remove('is-error');
      }
      return true;
    }

    refreshConfiguredPreview(options = {}) {
      this.currentPreview = null;
      this.restoreOriginalPreview();
      if (this.previewStatus) {
        this.previewStatus.textContent = SOFA_CONFIGURATOR_NO_PREVIEW_MESSAGE;
        this.previewStatus.classList.remove('is-error');
      }
      return false;
    }

    restoreOriginalPreview() {
      const image = this.querySelector('.sofa-configurator__image');
      if (image && this.originalImage) {
        image.setAttribute('src', this.originalImage.srcAttribute);
        if (this.originalImage.srcset) image.setAttribute('srcset', this.originalImage.srcset); else image.removeAttribute('srcset');
        if (this.originalImage.sizes) image.setAttribute('sizes', this.originalImage.sizes); else image.removeAttribute('sizes');
      }
      if (this.restorePreviewButton) this.restorePreviewButton.hidden = true;
      if (this.previewDisclaimer) this.previewDisclaimer.hidden = true;
      if (this.imageNote) {
        this.imageNote.textContent = 'Originalbild des Produkts';
        this.imageNote.classList.remove('is-generated');
      }
      this.updateImageDirection();
    }

    updateImageDirection() {
      const image = this.querySelector('.sofa-configurator__image');
      if (!image || !this.sourceDirection || !this.state.direction) return;
      image.classList.toggle('is-mirrored', this.isPreviewMirrored());
    }

    usesDirectSourceDirection() {
      return this.usesProductDirectionSource()
        || SOFA_CONFIGURATOR_DIRECT_SOURCE_DIRECTION_HANDLES.has(this.dataset.productHandle || '');
    }

    isPreviewMirrored() {
      if (!this.sourceDirection || !this.state.direction) return false;
      const sameDirection = this.normalize(this.sourceDirection) === this.normalize(this.state.direction);

      // In der Variante ohne Bildgenerierung kommt das Ausgangsbild direkt von
      // der gewaehlten Shopify-Variante. Gleiche Ausrichtung bleibt daher immer
      // unveraendert; nur die Gegenrichtung wird gespiegelt.
      if (!SOFA_CONFIGURATOR_IMAGE_PREVIEW_ENABLED) return !sameDirection;

      // These models use direct source labels: when source and selection match,
      // keep the source orientation. Other ottoman-labelled models retain the
      // inverse global v37 mapping.
      return this.usesDirectSourceDirection() ? !sameDirection : sameDirection;
    }

    previewCacheKeyFor(direction, sourceVariant) {
      return [
        'shopify-reference-pair-v9',
        this.dataset.productHandle,
        sourceVariant?.id || 'no-source-variant',
        this.normalize(direction || 'no-direction'),
        this.state.material?.key,
        this.state.accentMaterialKey || 'same-material',
        this.state.main?.id,
        this.state.singleColor ? 'single' : this.state.accent?.id
      ].join('|');
    }

    previewCacheKey() {
      const exactVariant = this.findExactConfiguredVariant(this.state.direction);
      const sourceVariant = exactVariant || this.findPreferredOriginalVariant(this.state.direction || '') || this.originalSourceVariant;
      return this.previewCacheKeyFor(this.state.direction, sourceVariant);
    }

    previewAltText() {
      const direction = this.state.direction ? `, Ausrichtung ${this.state.direction}` : '';
      if (this.state.singleColor) {
        return `KI-Farbvorschau ${this.inferModelName()} komplett in ${this.state.material?.name || 'Stoff'}, Farbe ${this.state.main?.label || ''}${direction}`;
      }
      return `KI-Farbvorschau ${this.inferModelName()} in ${this.state.main?.label || ''} und ${this.state.accent?.label || ''}${direction}`;
    }

    sourceImageFilename(source = this.originalImage?.src || '') {
      try {
        const pathname = new URL(source, window.location.origin).pathname;
        return decodeURIComponent(pathname.split('/').filter(Boolean).pop() || '');
      } catch (_error) {
        return '';
      }
    }

    async generatePreview() {
      this.currentPreview = null;
      this.restoreOriginalPreview();
      this.updatePreviewAvailability();
    }

    async createPreviewForDirection(direction, endpoint, useStoredPreview) {
      const exactVariant = this.findExactConfiguredVariant(direction);
      if (exactVariant) {
        const preview = this.previewFromShopifyVariant(exactVariant, direction);
        preview.targetDirection = direction;
        return preview;
      }

      const sourceVariant = this.findPreferredOriginalVariant(direction) || this.originalSourceVariant || this.getCurrentVariant();
      const cacheKey = this.previewCacheKeyFor(direction, sourceVariant);
      if (useStoredPreview && this.previewCache.has(cacheKey)) {
        return { ...this.previewCache.get(cacheKey), targetDirection: direction };
      }
      const query = new URLSearchParams({
        handle: this.dataset.productHandle || '',
        material: this.state.material?.name || '',
        mainColor: this.state.main?.label || '',
        accentColor: this.state.singleColor ? '' : (this.state.accent?.label || ''),
        direction: direction || '',
        singleColor: String(this.state.singleColor)
      });
      const result = await fetch(`${endpoint}?${query.toString()}`, { method: 'GET', cache: 'no-store' });
      const payload = await result.json().catch(() => ({}));
      if (!result.ok || !payload.image) throw new Error(payload.error || `Für ${direction || 'Standard'} ist noch keine geprüfte Vorschau vorhanden.`);
      return {
        cacheKey,
        image: payload.image,
        cartImage: payload.cartImage || '',
        altText: payload.altText || '',
        sourceVariant,
        sourceDirection: this.directionIndex >= 0 ? sourceVariant?.options?.[this.directionIndex] : direction,
        targetDirection: direction,
        exactShopify: false,
        approved: true
      };
    }

    showGeneratedPreview(source) {
      const image = this.querySelector('.sofa-configurator__image');
      if (!image) return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = source;
      if (this.restorePreviewButton) this.restorePreviewButton.hidden = false;
      if (this.previewDisclaimer) this.previewDisclaimer.hidden = false;
      if (this.imageNote) {
        this.imageNote.textContent = 'Geprüfte Farbvorschau – diese Version wurde vor der Anzeige manuell freigegeben.';
        this.imageNote.classList.add('is-generated');
      }
      this.updateImageDirection();
    }

    showShopifyProductPreview(source) {
      const image = this.querySelector('.sofa-configurator__image');
      if (!image) return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = source;
      if (this.restorePreviewButton) this.restorePreviewButton.hidden = true;
      if (this.previewDisclaimer) this.previewDisclaimer.hidden = true;
      if (this.imageNote) {
        this.imageNote.textContent = 'Vorhandenes Shopify-Produktbild – diese Kombination ist bereits als fertiges Produktbild hinterlegt.';
        this.imageNote.classList.remove('is-generated');
      }
      this.updateImageDirection();
    }

    absoluteUrl(value) {
      try { return new URL(value, window.location.origin).href; } catch (_error) { return value || ''; }
    }

    lockPageScroll() {
      if (this.pageScrollLock) return;
      this.pageScrollLock = {
        y: window.scrollY,
        position: document.body.style.position,
        top: document.body.style.top,
        width: document.body.style.width
      };
      document.documentElement.classList.add('sofa-configurator-open');
      document.body.classList.add('sofa-configurator-open');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.pageScrollLock.y}px`;
      document.body.style.width = '100%';
    }

    unlockPageScroll() {
      if (!this.pageScrollLock) return;
      const lock = this.pageScrollLock;
      document.documentElement.classList.remove('sofa-configurator-open');
      document.body.classList.remove('sofa-configurator-open');
      document.body.style.position = lock.position;
      document.body.style.top = lock.top;
      document.body.style.width = lock.width;
      this.pageScrollLock = null;
      window.scrollTo(0, lock.y);
    }

    inferModelName() {
      const explicit = (this.dataset.modelName || '').trim();
      const fullTitle = this.dataset.productTitle || explicit;
      if (explicit && explicit !== fullTitle) return explicit;
      return fullTitle
        .replace(/\b(couch|sofa|ecksofa|wohnlandschaft|xxl|xl|l-form|u-form|in stoff|aus stoff|in leder|aus leder|komfort|stil|mit led)\b/giu, ' ')
        .replace(/[^\p{L}\p{N}]+/gu, ' ')
        .replace(/\s+/gu, ' ')
        .trim() || fullTitle;
    }

    clearError() { if (this.error) { this.error.hidden = true; this.error.textContent = ''; } }
    showPreviewError(message) { if (this.previewStatus) { this.previewStatus.textContent = message; this.previewStatus.classList.add('is-error'); } }
    showError(message) { if (this.error) { this.error.textContent = message; this.error.hidden = false; this.error.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }
    normalize(value) { return String(value || '').trim().toLocaleLowerCase('de-DE').replace(/ü/gu, 'ue').replace(/ö/gu, 'oe').replace(/ä/gu, 'ae').replace(/ß/gu, 'ss').replace(/[^a-z0-9]+/gu, ' ').trim(); }
    escape(value) { const element = document.createElement('span'); element.textContent = String(value || ''); return element.innerHTML; }
  });
}
